import { disableGtag } from '@repo/ui/lib/gtag';
import posthog from 'posthog-js';
import { GA_MEASUREMENT_ID } from '@/lib/analytics/ga-measurement-id';
import { clearAnalyticsBrowserStorage } from '@/lib/cookie-consent/storage';

/**
 * Stop product analytics (PostHog and GA4) and drop the identifiers they already stored.
 * Necessary cookies (sign-in, security) are left alone.
 *
 * Analytics stays unloaded until the visitor chooses Accept, including when
 * the browser sends Global Privacy Control. An explicit Accept after that
 * signal is the visitor opting in to first-party analytics.
 */
export function stopAnalytics() {
    try {
        if (posthog.__loaded) {
            posthog.opt_out_capturing();
        }
    } catch {
        // The SDK was never started.
    }
    if (GA_MEASUREMENT_ID) disableGtag(GA_MEASUREMENT_ID);
    clearAnalyticsBrowserStorage();
}
